import styled from 'styled-components'
import { Button, Typography } from 'antd'

export const ConverterSection = styled.div`
  margin-bottom: 16px;
`

export const ConverterButton = styled(Button)`
  padding: 0;
  height: auto;
  font-weight: 500;
  color: #1890ff;
  
  &:hover {
    color: #40a9ff;
  }
`

export const ConvertButton = styled(Button)`
  margin-top: 8px;
`

export const ResultSection = styled.div`
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #ffffff;
`

export const CopyButton = styled(Button)`
  &.ant-btn-sm {
    height: 24px;
    padding: 0 8px;
    font-size: 12px;
  }
`

export const ErrorText = styled(Typography.Text)`
  color: #ff4d4f;
  font-size: 13px;
  display: block;
  margin-top: 8px;
`